// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_LinkExpensesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for link_expenses /payroll/link_expenses
 *
 * Action endpoint — links expense rows to a payroll period.
 * No payload: dados is always null on success; failures route through
 * sendError() and never reach this contract.
 *
 * @see Payroll::link_expenses() controller
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_LinkExpensesResponseDados = null;

export type Payroll_LinkExpensesResponse = ApiResponse<Payroll_LinkExpensesResponseDados>;

registerResponseContract('Payroll_LinkExpensesResponse', {})
